import React from 'react';
import MarketingPDF from './marketing url.pdf';
import AllPagesPDFViewer from "../../components/pdf/all-pages";
import './pitchdeck.css';

export default function Test() {
    return (
        <AllPagesPDFViewer pdf={MarketingPDF}/>
    );
}